/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportCatalogXLSX200Response
 */
export interface ImportCatalogXLSX200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ImportCatalogXLSX200Response
     */
    success: boolean;
}

/**
 * Check if a given object implements the ImportCatalogXLSX200Response interface.
 */
export function instanceOfImportCatalogXLSX200Response(value: object): value is ImportCatalogXLSX200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function ImportCatalogXLSX200ResponseFromJSON(json: any): ImportCatalogXLSX200Response {
    return ImportCatalogXLSX200ResponseFromJSONTyped(json, false);
}

export function ImportCatalogXLSX200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportCatalogXLSX200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function ImportCatalogXLSX200ResponseToJSON(json: any): ImportCatalogXLSX200Response {
    return ImportCatalogXLSX200ResponseToJSONTyped(json, false);
}

export function ImportCatalogXLSX200ResponseToJSONTyped(value?: ImportCatalogXLSX200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

